module.exports = __webpack_public_path__ + "img/menuFinance.1c3aeb40.png";